import { Badge } from '@/components/ui/badge';
import { VolumeStatus } from '@/service/gpu-instance/volume-type';
import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

interface VolumeStatusBadgeProps {
  status: VolumeStatus;
  className?: string;
}

const statusConfig: Record<
  VolumeStatus,
  { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline'; className?: string; showSpinner?: boolean }
> = {
  [VolumeStatus.Available]: {
    label: 'Available',
    variant: 'outline',
    className: 'border-green-500 text-green-600 bg-green-50 dark:bg-green-950/30',
  },
  [VolumeStatus.InUse]: {
    label: 'In Use',
    variant: 'default',
    className: 'bg-blue-500 hover:bg-blue-600',
  },
  [VolumeStatus.Pending]: {
    label: 'Pending',
    variant: 'secondary',
    className: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
    showSpinner: true,
  },
  [VolumeStatus.Expanding]: {
    label: 'Expanding',
    variant: 'secondary',
    className: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
    showSpinner: true,
  },
  [VolumeStatus.Deleting]: {
    label: 'Deleting',
    variant: 'secondary',
    className: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
    showSpinner: true,
  },
  [VolumeStatus.Error]: {
    label: 'Error',
    variant: 'destructive',
  },
};

export const VolumeStatusBadge = ({ status, className }: VolumeStatusBadgeProps) => {
  const config = statusConfig[status];

  return (
    <Badge variant={config.variant} className={cn('gap-1', config.className, className)}>
      {config.showSpinner && <Loader2 className="h-3 w-3 animate-spin" />}
      {config.label}
    </Badge>
  );
};

export default VolumeStatusBadge;
